// removed by extract-text-webpack-plugin
module.exports = {"theme":"#ff7d3f","menuActive":"#ea6c41"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 36